import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/Badge';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface BetaTagProps {
    className?: string;
}

export function BetaTag({ className }: BetaTagProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);
    return <Badge className={className}>{t('beta')}</Badge>;
}
